<template>
  <div class="evento-status">
    <b-row>
      <b-col cols="12" xl="12">  
        <b-card header="Status del Evento">
          <div class="status-chart">
            <div class="status-chart-title">
              <h4>Evolución de Transferencias</h4>
              <!-- <p class="description">Evolución de la participación sobre las ventas de los conceptos incluidos en el cálculo de la RN</p> -->
            </div>
            <app-line-evolucion-transferencias 
              chartId="evolucion-transferencias"
              class="chart-wrapper"
              ref="evolucionTransferencias"
              :stepSize="transferenciasEvolucionStep"
              :max="transferenciasEvolucionMax"
              :yAxisCurrency="true"
              :yAxisPercentaje="false">
            </app-line-evolucion-transferencias>
          </div>

          <hr class="dashboard">

          <div class="status-chart">
            <div class="status-chart-title">
              <h4>Transferencias Acreditadas</h4>
              <!-- <p class="description">Últimos 12 meses</p> -->
            </div>
            <b-table hover
                responsive="sm" 
                class="registro"
                :busy="tableTransferenciasPeriodosBusy"
                :items="transferenciasPeriodos" 
                :fields="transferenciasPeriodosFields"
                :current-page="paginaActualTransferenciasPeriodos"
                :per-page="registrosPorPaginaTransferenciasPeriodos">
              <div slot="table-busy" class="text-center">
                <b-spinner class="table-spinner" label="Spinning" />
              </div>
              <template v-slot:cell(periodo)="data">
                {{ data.item.periodo | periodo }}
              </template>
              <template v-slot:cell(importeAcreditadas)="data">
                {{ data.item.importeAcreditadas | moneda }}
              </template>
              <template v-slot:cell(importeRechazadas)="data">
                {{ data.item.importeRechazadas | moneda }}
              </template>
            </b-table>
            <nav>
              <b-pagination size="sm" 
                :total-rows="totalRegistrosTransferenciasPeriodos" 
                :per-page="registrosPorPaginaTransferenciasPeriodos" 
                v-model="paginaActualTransferenciasPeriodos" prev-text="Prev." next-text="Prox."/>
            </nav>
          </div>

          <hr class="dashboard">
          
          <div class="status-chart"> 
            <div class="status-chart-title">
              <h4>Evolución de Resultados de Transferencias</h4>
              <!-- <p class="description">Evolución de la participación sobre las ventas de los conceptos incluidos en el cálculo de la RN</p> -->
            </div>
            <app-bar-evolucion-resultados
              chartId="evolucion-transferencias-resultados" 
              class="chart-wrapper"
              ref="evolucionTransferenciasResultados">
            </app-bar-evolucion-resultados>
          </div>

          <hr class="dashboard">

          <div class="status-chart">
            <div class="status-chart-title">
              <h4>Participantes</h4>
              <p class="description">Top10 de participantes por monto transferido</p>
            </div>
            <b-table hover
                responsive="sm" 
                class="registro"
                :busy="tableTransferenciasParticipantesBusy"
                :items="transferenciasParticipantes" 
                :fields="transferenciasParticipantesFields">
              <div slot="table-busy" class="text-center">
                <b-spinner class="table-spinner" label="Spinning" />
              </div>
              <template v-slot:cell(importe)="data">
                {{ data.item.importe | moneda }}
              </template>
            </b-table>
          </div>

          <hr class="dashboard" v-if="eventoId == 145">

          <div class="status-chart" v-if="eventoId == 145">
            <div class="status-chart-title">
              <h4>Clasificacion de Puntos de Venta</h4>
              <!-- <p class="description">Top10 de participantes por monto transferido</p> -->
            </div>
            <b-row>
              <b-col sm="5" lg="5">
                <div class="chart">
                  <app-pie ref="clasificacionPuntosVenta"></app-pie>
                  <!-- <label class="description">Excluye retenciones y pago de impuestos</label> -->
                </div>
              </b-col>
              <b-col sm="7" lg="7">
                <b-table hover
                    responsive="sm" 
                    class="registro"
                    :busy="tableclasificacionPuntosVentaGenExpertosBusy"
                    :items="clasificacionPuntosVentaGenExpertos" 
                    :fields="clasificacionPuntosVentaGenExpertosFields">
                  <div slot="table-busy" class="text-center">
                    <b-spinner class="table-spinner" label="Spinning" />
                  </div>
                  <template v-slot:cell(color)="data">
                      <div class="color-reference" :style='"background-color: " + getColor(data.item) + ";"'></div>              
                  </template>
                  <template v-slot:cell(pjeParticipacion)="data">
                    {{ data.item.pjeParticipacion | porcentaje }}
                  </template>
                </b-table>
              </b-col>
            </b-row>
          </div>

          <hr class="dashboard" v-if="eventoId == 145">

          <div class="status-chart"  v-if="eventoId == 145">
            <div class="status-chart-title">
              <h4>Cadenas - GenExpertos</h4>
              <p class="description">Participantes por cadena</p>
            </div>
            <b-table hover
                responsive="sm" 
                class="registro"
                :busy="tableCadenasBusy"
                :items="cadenasGenExpertos" 
                :fields="cadenasGenExpertosFields"
                :current-page="paginaActualCadenasGenExpertos"
                :per-page="registrosPorPaginaCadenasGenExpertos">
              <div slot="table-busy" class="text-center">
                <b-spinner class="table-spinner" label="Spinning" />
              </div>
              <template v-slot:cell(importe)="data">
                {{ data.item.importe | moneda }}
              </template>
            </b-table>
            <nav>
              <b-pagination size="sm" 
                :total-rows="totalRegistrosCadenasGenExpertos" 
                :per-page="registrosPorPaginaCadenasGenExpertos" 
                v-model="paginaActualCadenasGenExpertos" prev-text="Prev." next-text="Prox."/>
            </nav>
          </div>
        </b-card>
      </b-col>
    </b-row>

    <div class="fixed-btn">
      <div class="data-goback-btn" @click.prevent="goBack">
          <i class="fa fa-undo fa-2x" aria-hidden="true"></i>
      </div>
    </div>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import LineEvolucionTransferencias from '../charts/LineEvolucion.vue';
import BarEvolucionResultados from '../charts/Bar.vue';
import Pie from '../charts/Pie.vue';
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'eventoStatus/getField',
  mutationType: 'eventoStatus/updateField',
});

export default {
  name: 'EventoStatus',
  components: {
    appLineEvolucionTransferencias: LineEvolucionTransferencias,
    appBarEvolucionResultados: BarEvolucionResultados,
    appPie: Pie,
    appMensaje: Mensaje,
  },
  mixins: [ 
    msjModal, 
  ],
  data: () => {
    return {
      eventoId: 0,

      tableTransferenciasPeriodosBusy: false,
      transferenciasPeriodosFields: [
        { 
          key: 'periodo', 
          sortable: true 
        },
        { 
          key: 'importeAcreditadas',
          label: 'Acreditadas', 
          class: 'text-right' 
        },
        { 
          key: 'cantidadAcreditadas',
          label: 'Cant.Acreditadas',
          class: 'text-right' 
        },
        { 
          key: 'importeRechazadas',
          label: 'Rechazadas', 
          class: 'text-right' 
        },
        { 
          key: 'cantidadRechazadas',
          label: 'Cant.Rechazadas',
          class: 'text-right' 
        },
      ],
      paginaActualTransferenciasPeriodos: 1,
      registrosPorPaginaTransferenciasPeriodos: 10,
      totalRegistrosTransferenciasPeriodos: 0,
      totalPaginasTransferenciasPeriodos: 0,

      tableTransferenciasParticipantesBusy: false,
      transferenciasParticipantesFields: [
        { 
          key: 'participante', 
          sortable: true 
        },
        { 
          key: 'importe', 
          class: 'text-right' 
        },
        { 
          key: 'cantidad', 
          class: 'text-right' 
        },
      ],

      tableCadenasBusy: false,
      cadenasGenExpertosFields: [
        { 
          key: 'cadena', 
          sortable: true 
        },
        { 
          key: 'cantidad',
          label: 'Puntos de Venta',
          class: 'text-right',
          sortable: true
        },
      ],
      paginaActualCadenasGenExpertos: 1,
      registrosPorPaginaCadenasGenExpertos: 10,
      totalRegistrosCadenasGenExpertos: 0,
      totalPaginasCadenasGenExpertos: 0,
      
      tableclasificacionPuntosVentaGenExpertosBusy: false,
      clasificacionPuntosVentaGenExpertosFields: [
        { 
          key: 'color', 
          label: 'Ref.',
        },
        { 
          key: 'nombre', 
          label: 'Tipo',
        },
        { 
          key: 'cantidad',
          class: 'text-right' 
        },
        { 
          key: 'pjeParticipacion',
          label: '% Participación',
          class: 'text-right' 
        },
      ],
    }
  },
  computed: {
    ...mapFields([
      'transferenciasEvolucion',
      'transferenciasEvolucionPeriodos',
      'transferenciasEvolucionMax',
      'transferenciasEvolucionStep',

      'transferenciasPeriodos',

      'transferenciasResultados',
      'transferenciasResultadosPeriodos',
      'transferenciasResultadosMax',
      'transferenciasResultadosStep',

      'transferenciasParticipantes',

      'cadenasGenExpertos',

      'clasificacionPuntosVentaGenExpertos',
      'clasificacionPuntosVentaGenExpertosLabels',
      'clasificacionPuntosVentaGenExpertosColors',
      'clasificacionPuntosVentaGenExpertosData',
    ]),
  },
  created() {
    this.eventoId = this.$route.params.id;

    this.showSpinner();
    this.$store.dispatch('eventoStatus/inicializar', this.eventoId)
      .then(this.getStatus())
      .catch(error => this.showErrorMsj(error))
      .finally(() => this.hideSpinner());
  },  
  methods: {
    getStatus() {
      this.tableTransferenciasPeriodosBusy = true;
      this.$store.dispatch('eventoStatus/getTransferenciasPeriodos')
        .then(() => {
          this.totalRegistrosTransferenciasPeriodos = this.transferenciasPeriodos.length;
          // console.log(this.transferenciasEvolucionPeriodos);
          // console.log(this.transferenciasEvolucion);
          this.$refs.evolucionTransferencias.render(this.transferenciasEvolucionPeriodos, this.transferenciasEvolucion)
        })
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.tableTransferenciasPeriodosBusy = false);
      
      this.$store.dispatch('eventoStatus/getTransferenciasResultados')
        .then(() => {
          this.$refs.evolucionTransferenciasResultados.render(this.transferenciasResultadosPeriodos, 
            this.transferenciasResultados,
            parseInt(this.transferenciasResultadosStep),
            parseInt(this.transferenciasResultadosMax))
        })
        .catch(error => this.showErrorMsj(error));
      
      this.tableTransferenciasParticipantesBusy = true;
      this.$store.dispatch('eventoStatus/getTransferenciasParticipantes')
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.tableTransferenciasParticipantesBusy = false);
      
      /* GenExpertos */
      if (this.eventoId == 145) {
        this.tableCadenasBusy = true;
        this.$store.dispatch('eventoStatus/getCadenasGenExpertos')
          .then(() => {
            this.totalRegistrosCadenasGenExpertos = this.cadenasGenExpertos.length;
          })
          .catch(error => this.showErrorMsj(error))
          .finally(() => this.tableCadenasBusy = false);
        
        this.tableclasificacionPuntosVentaGenExpertosBusy = true;
        this.$store.dispatch('eventoStatus/getClasificacionPuntosVentaGenExpertos')
          .then(() => {
            let labels = this.clasificacionPuntosVentaGenExpertosLabels;
            let colors = this.clasificacionPuntosVentaGenExpertosColors;
            let data = this.clasificacionPuntosVentaGenExpertosData;

            this.$refs.clasificacionPuntosVenta.render(labels, colors, data, false);
          })
          .catch(error => this.showErrorMsj(error))
          .finally(() => this.tableclasificacionPuntosVentaGenExpertosBusy = false);
      }
    },
    goBack() {
      this.$router.go(-1);
    },
    getColor(item) {
      return item.color;
    },    
  }
}
</script>

<style>
  .status-chart {
    position: relative;
    padding-left: 5%;
    padding-right: 5%;
    margin-bottom: 30px;
    /* padding-bottom: 10%;     */
  }
  .status-chart-title {
    margin-top: 20px;
    margin-bottom: 20px;
  }
  .status-chart-title h4 {
    margin-bottom: 5px;
  }
  .status-chart-title p.description {
    font-size: 0.8em;
    font-style: italic;
    margin-bottom: 5px;    
  }
  .status-chart table {
    position: relative;
  }
  .status-chart table thead th {
    border-top: none;
  }
  .chart-wrapper {
    position: relative;
    height: 380px;
    margin-bottom: 30px;
  }

  .status-chart .chart {
    position: relative;
    padding-left: 10%;
    padding-right: 10%;
    padding-bottom: 10%;    
    /* top: 20px;
    padding-left: 20px;
    padding-right: 20px; */
  }
  .status-chart .chart .description {
    font-size: 12px;
    font-style: italic;
  }
  .status-chart table .color-reference {
    display: inline-block;
    position: relative;
    /* margin-right: 5px; */
    width: 24px; 
    height: 12px; 
    top: 2px;
  }


</style>